import { render, staticRenderFns } from "./DomainEdit.vue?vue&type=template&id=cfc77fa6&scoped=true"
import script from "./DomainEdit.vue?vue&type=script&lang=ts"
export * from "./DomainEdit.vue?vue&type=script&lang=ts"
import style0 from "./DomainEdit.vue?vue&type=style&index=0&id=cfc77fa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc77fa6",
  null
  
)

export default component.exports